import Ad from './Ad';

export * from './Ad';

export default Ad;
